module.exports = __webpack_public_path__ + "static/media/tournament-masthead-enduro.2333ac5e.jpg";